import { type CommunicationType, CommunicationTypeEnum } from '@/models'

export const isPushNotificationType = (type?: CommunicationType) => {
  return type === CommunicationTypeEnum.enum.Notification
}

export const isEmailType = (type?: CommunicationType) => {
  return type === CommunicationTypeEnum.enum.Email
}

export const isSmsType = (type?: CommunicationType) => {
  return type === CommunicationTypeEnum.enum.SMS
}
